import { CALL_API } from "../../../middlewares/api";

export const GET_AML_RULES_REQUEST = "GET_AML_RULES_REQUEST";
export const GET_AML_RULES_SUCCESS = "GET_AML_RULES_SUCCESS";
export const GET_AML_RULES_ERROR = "GET_AML_RULES_ERROR";

export const get_aml_rules = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/aml/get-rules",
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_AML_RULES_REQUEST,
        GET_AML_RULES_SUCCESS,
        GET_AML_RULES_ERROR,
      ],
    },
  };
};

export const SET_AML_WARNINGS_STATUS_REQUEST =
  "SET_AML_WARNINGS_STATUS_REQUEST";
export const SET_AML_WARNINGS_STATUS_SUCCESS =
  "SET_AML_WARNINGS_STATUS_SUCCESS";
export const SET_AML_WARNINGS_STATUS_ERROR = "SET_AML_WARNINGS_STATUS_ERROR";

export const set_aml_warning_status = (data, shouldCreateSendBackOrder) => {
  let successMethod = shouldCreateSendBackOrder
    ? aml_status_success_create_send_back_order.bind(this, data)
    : aml_status_set_success.bind(this, data);

  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/aml/set-aml-warning-status",
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        SET_AML_WARNINGS_STATUS_REQUEST,
        { method: successMethod },
        SET_AML_WARNINGS_STATUS_ERROR,
      ],
    },
  };
};

const aml_status_success_create_send_back_order = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: SET_AML_WARNINGS_STATUS_SUCCESS,
      dataSent: data,
      response,
    });
    dispatch(create_send_back_order(data));
  };
};

const aml_status_set_success = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: SET_AML_WARNINGS_STATUS_SUCCESS,
      dataSent: data,
      response,
    });
    dispatch(get_aml_statuses(data.WarningId));
  };
};

export const CREATE_SEND_BACK_ORDER_REQUEST = "CREATE_SEND_BACK_ORDER_REQUEST";
export const CREATE_SEND_BACK_ORDER_SUCCESS = "CREATE_SEND_BACK_ORDER_SUCCESS";
export const CREATE_SEND_BACK_ORDER_ERROR = "CREATE_SEND_BACK_ORDER_ERROR";

export const create_send_back_order = (data) => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/create-send-back-order",
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        CREATE_SEND_BACK_ORDER_REQUEST,
        { method: create_send_back_order_success.bind(this, data) },
        CREATE_SEND_BACK_ORDER_ERROR,
      ],
    },
  };
};

const create_send_back_order_success = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: CREATE_SEND_BACK_ORDER_SUCCESS,
      dataSent: data,
      response,
    });
    dispatch(get_aml_warnings());
  };
};

export const SET_LOANSTEP_AML_WARNINGS_STATUS_REQUEST =
  "SET_LOANSTEP_AML_WARNINGS_STATUS_REQUEST";
export const SET_LOANSTEP_AML_WARNINGS_STATUS_SUCCESS =
  "SET_LOANSTEP_AML_WARNINGS_STATUS_SUCCESS";
export const SET_LOANSTEP_AML_WARNINGS_STATUS_ERROR =
  "SET_LOANSTEP_AML_WARNINGS_STATUS_ERROR";

export const set_loanstep_aml_warning_status = (
  amlWarningsId,
  status,
  notes,
) => {
  const data = {
    WarningId: amlWarningsId,
    Status: status,
    Note: notes,
  };

  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/aml/set-aml-warning-status",
      authenticatedRequest: true,
      method: "POST",
      data,
      types: [
        SET_LOANSTEP_AML_WARNINGS_STATUS_REQUEST,
        { method: loanstep_aml_status_set_success.bind(this, data) },
        SET_LOANSTEP_AML_WARNINGS_STATUS_ERROR,
      ],
    },
  };
};

const loanstep_aml_status_set_success = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: SET_LOANSTEP_AML_WARNINGS_STATUS_SUCCESS,
      dataSent: data,
      response,
    });

    dispatch(get_loanstep_aml_warnings());
  };
};

export const GET_AML_WARNINGS_REQUEST = "GET_AML_WARNINGS_REQUEST";
export const GET_AML_WARNINGS_SUCCESS = "GET_AML_WARNINGS_SUCCESS";
export const GET_AML_WARNINGS_ERROR = "GET_AML_WARNINGS_ERROR";

export const get_aml_warnings = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/aml/get-warnings",
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_AML_WARNINGS_REQUEST,
        GET_AML_WARNINGS_SUCCESS,
        GET_AML_WARNINGS_ERROR,
      ],
    },
  };
};

export const GET_PERSONAL_AML_WARNINGS_REQUEST =
  "GET_PERSONAL_AML_WARNINGS_REQUEST";
export const GET_PERSONAL_AML_WARNINGS_SUCCESS =
  "GET_PERSONAL_AML_WARNINGS_SUCCESS";
export const GET_PERSONAL_AML_WARNINGS_ERROR =
  "GET_PERSONAL_AML_WARNINGS_ERROR";

export const get_investor_deposit_aml_warnings = (investorId) => {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/savelend/aml/get-warnings-for-investor?OnlyDepositWarnings=true&InvestorId=" +
        investorId,
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_PERSONAL_AML_WARNINGS_REQUEST,
        GET_PERSONAL_AML_WARNINGS_SUCCESS,
        GET_PERSONAL_AML_WARNINGS_ERROR,
      ],
    },
  };
};

export const GET_LOANSTEP_AML_WARNINGS_REQUEST =
  "GET_LOANSTEP_AML_WARNINGS_REQUEST";
export const GET_LOANSTEP_AML_WARNINGS_SUCCESS =
  "GET_LOANSTEP_AML_WARNINGS_SUCCESS";
export const GET_LOANSTEP_AML_WARNINGS_ERROR =
  "GET_LOANSTEP_AML_WARNINGS_ERROR";

export const get_loanstep_aml_warnings = () => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/aml/get-warnings",
      authenticatedRequest: true,
      method: "GET",
      types: [
        GET_LOANSTEP_AML_WARNINGS_REQUEST,
        GET_LOANSTEP_AML_WARNINGS_SUCCESS,
        GET_LOANSTEP_AML_WARNINGS_ERROR,
      ],
    },
  };
};

export const GET_AML_WARNINGS_ACTIONS_REQUEST =
  "GET_AML_WARNINGS_ACTIONS_REQUEST";
export const GET_AML_WARNINGS_ACTIONS_SUCCESS =
  "GET_AML_WARNINGS_ACTIONS_SUCCESS";
export const GET_AML_WARNINGS_ACTIONS_ERROR = "GET_AML_WARNINGS_ACTIONS_ERROR";

export const get_aml_statuses = (amlWarningId) => {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/savelend/aml/get-aml-warning-status-history-items?warningId=" +
        amlWarningId,
      authenticatedRequest: true,
      additionalData: { AmlWarningId: amlWarningId },
      method: "GET",
      types: [
        GET_AML_WARNINGS_ACTIONS_REQUEST,
        GET_AML_WARNINGS_ACTIONS_SUCCESS,
        GET_AML_WARNINGS_ACTIONS_ERROR,
      ],
    },
  };
};

export const GET_LOANSTEP_AML_WARNINGS_ACTIONS_REQUEST =
  "GET_LOANSTEP_AML_WARNINGS_ACTIONS_REQUEST";
export const GET_LOANSTEP_AML_WARNINGS_ACTIONS_SUCCESS =
  "GET_LOANSTEP_AML_WARNINGS_ACTIONS_SUCCESS";
export const GET_LOANSTEP_AML_WARNINGS_ACTIONS_ERROR =
  "GET_LOANSTEP_AML_WARNINGS_ACTIONS_ERROR";

export const get_loanstep_aml_statuses = (amlWarningId) => {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loanstep/aml/get-aml-warning-status-history-items?warningId=" +
        amlWarningId,
      authenticatedRequest: true,
      additionalData: { AmlWarningId: amlWarningId },
      method: "GET",
      types: [
        GET_LOANSTEP_AML_WARNINGS_ACTIONS_REQUEST,
        GET_LOANSTEP_AML_WARNINGS_ACTIONS_SUCCESS,
        GET_LOANSTEP_AML_WARNINGS_ACTIONS_ERROR,
      ],
    },
  };
};

export const SET_INVESTOR_AML_RISK_LEVEL_REQUEST =
  "SET_INVESTOR_AML_RISK_LEVEL_REQUEST";
export const SET_INVESTOR_AML_RISK_LEVEL_SUCCESS =
  "SET_INVESTOR_AML_RISK_LEVEL_SUCCESS";
export const SET_INVESTOR_AML_RISK_LEVEL_ERROR =
  "SET_INVESTOR_AML_RISK_LEVEL_ERROR";

export const set_investor_aml_risk_level = (riskLevel, note, investorId) => {
  const data = {
    RiskLevel: riskLevel,
    InvestorId: investorId,
    Note: note,
  };
  return {
    [CALL_API]: {
      endpoint: "/api/admin/savelend/aml/set-investor-risk-level",
      authenticatedRequest: true,
      data,
      method: "POST",
      types: [
        SET_INVESTOR_AML_RISK_LEVEL_REQUEST,
        { method: investor_risk_level_notes_success_action.bind(this, data) },
        SET_INVESTOR_AML_RISK_LEVEL_ERROR,
      ],
    },
  };
};

export const SET_BORROWER_AML_RISK_LEVEL_REQUEST =
  "SET_BORROWER_AML_RISK_LEVEL_REQUEST";
export const SET_BORROWER_AML_RISK_LEVEL_SUCCESS =
  "SET_BORROWER_AML_RISK_LEVEL_SUCCESS";
export const SET_BORROWER_AML_RISK_LEVEL_ERROR =
  "SET_BORROWER_AML_RISK_LEVEL_ERROR";

export const set_borrower_aml_risk_level = (riskLevel, note, borrowerId) => {
  const data = {
    RiskLevel: riskLevel,
    BorrowerId: borrowerId,
    Note: note,
  };
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/aml/set-borrower-risk-level",
      authenticatedRequest: true,
      data,
      method: "POST",
      types: [
        SET_BORROWER_AML_RISK_LEVEL_REQUEST,
        { method: borrower_risk_level_notes_success_action.bind(this, data) },
        SET_BORROWER_AML_RISK_LEVEL_ERROR,
      ],
    },
  };
};

export const investor_risk_level_notes_success_action = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: SET_INVESTOR_AML_RISK_LEVEL_SUCCESS,
      dataSent: data,
      response,
    });

    dispatch(get_investor_aml_notes(data.InvestorId, "Aml"));
  };
};

export const borrower_risk_level_notes_success_action = (data, response) => {
  return (dispatch) => {
    dispatch({
      type: SET_BORROWER_AML_RISK_LEVEL_SUCCESS,
      dataSent: data,
      response,
    });

    dispatch(get_borrower_aml_notes(data.BorrowerId, "Aml"));
  };
};

export const GET_INVESTOR_AML_NOTES_REQUEST = "GET_INVESTOR_AML_NOTES_REQUEST";
export const GET_INVESTOR_AML_NOTES_SUCCESS = "GET_INVESTOR_AML_NOTES_SUCCESS";
export const GET_INVESTOR_AML_NOTES_ERROR = "GET_INVESTOR_AML_NOTES_ERROR";

export const get_investor_aml_notes = (investorId) => {
  const type = "Aml";
  const additionalData = {
    investorId: investorId,
    type: type,
  };
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/savelend/get-investor-by-id?investorId=" + investorId,
      authenticatedRequest: true,
      method: "GET",
      additionalData,
      types: [
        GET_INVESTOR_AML_NOTES_REQUEST,
        GET_INVESTOR_AML_NOTES_SUCCESS,
        GET_INVESTOR_AML_NOTES_ERROR,
      ],
    },
  };
};

export const GET_BORROWER_AML_NOTES_REQUEST = "GET_BORROWER_AML_NOTES_REQUEST";
export const GET_BORROWER_AML_NOTES_SUCCESS = "GET_BORROWER_AML_NOTES_SUCCESS";
export const GET_BORROWER_AML_NOTES_ERROR = "GET_BORROWER_AML_NOTES_ERROR";

export const get_borrower_aml_notes = (borrowerId) => {
  const type = "Aml";
  const additionalData = {
    borrowerId: borrowerId,
    type: type,
  };
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loanstep/get-borrower-by-id?borrowerId=" + borrowerId,
      authenticatedRequest: true,
      method: "GET",
      additionalData,
      types: [
        GET_BORROWER_AML_NOTES_REQUEST,
        GET_BORROWER_AML_NOTES_SUCCESS,
        GET_BORROWER_AML_NOTES_ERROR,
      ],
    },
  };
};
